/* eslint-disable no-restricted-syntax */

import inspect from "object-inspect";

export function numToStr(num: number): string {
	return num.toString();
}

export function bigintToStr(bigint: bigint): string {
	return bigint.toString();
}

export function URLSearchParamsToStr(params: URLSearchParams): string {
	return params.toString();
}

// here we explicitly want to be able to stringify any function
// eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
export function functionToStr(func: Function): string {
	return func.toString();
}

export function bufferToStr(buffer: Buffer, encoding?: BufferEncoding): string {
	return buffer.toString(encoding);
}

export function unknownToStr(unknown: unknown): string {
	if (typeof unknown === "string") {
		return unknown;
	}

	try {
		const res = JSON.stringify(unknown, null, 2);

		// JSON.stringify can actually return undefined for functions
		// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
		if (res === undefined || res === "{}") {
			return inspect(unknown, { depth: Infinity });
		}

		return res;
	} catch {
		return inspect(unknown, { depth: Infinity });
	}
}
